import { render, staticRenderFns } from "./edit-stakeholder.vue?vue&type=template&id=0048604e"
import script from "./edit-stakeholder.ts?vue&type=script&lang=js&external"
export * from "./edit-stakeholder.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports